module.exports = {
  siteUrl: 'http://localhost:8000',
  serverUrl: 'https://www-api.zoopay.com',
  gaEnabled: false,
  redirectAfterEnquiryTimeout: 15000,
}
